var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-731.5 -185.419)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(734.5 188.419)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.152,30.933h-7.2l4.249-4.106a8.49,8.49,0,0,0,2.758-6.263,7.908,7.908,0,0,0-.249-1.972A7.333,7.333,0,0,0,23.4,12.966a7.827,7.827,0,0,0-3.363.735v-.513A5.906,5.906,0,0,0,15.314,7.4a2.2,2.2,0,0,0,.513-.43l5.5.526h.023a.216.216,0,0,0,.152-.06.222.222,0,0,0,.074-.167V6.28a.222.222,0,0,0-.171-.217L16.316,4.881a2.9,2.9,0,0,0-.093-.282l.364-.5h2.54a2.43,2.43,0,0,0,1.736-.735l.647-.666a.23.23,0,0,0,.046-.245.226.226,0,0,0-.208-.138H15.582a.227.227,0,0,0-.175.083l-.711.887a2.15,2.15,0,0,0-.55-.069,2.256,2.256,0,0,0-1.871.993H7.619A4.088,4.088,0,0,0,3.535,8.291v9.6L2.69,25.7a.241.241,0,0,0,.056.175.222.222,0,0,0,.167.074H6.681a.224.224,0,0,0,.167-.074A.222.222,0,0,0,6.9,25.7l-.847-7.811V8.3A1.566,1.566,0,0,1,7.619,6.738h4.656a2.285,2.285,0,0,0,.7.666,5.907,5.907,0,0,0-4.725,5.783V30.933H2.5a.222.222,0,0,0,0,.443H31.148a.221.221,0,0,0,.222-.222.218.218,0,0,0-.217-.222ZM8.694,14.064h3.792V24.6H8.694Zm0,12.666h9.8c.032.032.064.064.1.093l1,.966v.993H8.694Zm11.345,2.277v-.785l2.808,2.712H20.039ZM30.28,18.7a7.429,7.429,0,0,1,.236,1.866A8.058,8.058,0,0,1,27.9,26.5L23.4,30.846,19.98,27.539l0,0L18.908,26.5c-.051-.046-.1-.093-.148-.143l-.014-.014a8.013,8.013,0,0,1-2.457-5.778,7.477,7.477,0,0,1,.236-1.866,6.921,6.921,0,0,1,6.882-5.289A6.919,6.919,0,0,1,30.279,18.7ZM21.124,6.457v.568l-5-.476A2.259,2.259,0,0,0,16.4,5.477c0-.042,0-.079,0-.12Zm-5.436-3.69h5.131l-.277.286a1.99,1.99,0,0,1-1.414.6H16.473a.224.224,0,0,0-.18.093l-.31.43a2.323,2.323,0,0,0-.846-.716ZM3.161,25.506l.8-7.368H5.632l.8,7.368ZM7.619,6.291A2.01,2.01,0,0,0,5.61,8.3v9.391H3.983V8.3A3.64,3.64,0,0,1,7.619,4.664h4.42a2.246,2.246,0,0,0,0,1.627Zm4.716-.813a1.809,1.809,0,0,1,1.807-1.807,1.764,1.764,0,0,1,.568.093h0a1.807,1.807,0,0,1-.563,3.52h-.019a1.81,1.81,0,0,1-1.8-1.807Zm1.8,2.254h.019a5.44,5.44,0,0,1,5.436,5.45v.748a7.339,7.339,0,0,0-3.506,4.661,7.869,7.869,0,0,0-.249,1.977,8.474,8.474,0,0,0,2.217,5.719H8.694V25.053h4.014a.221.221,0,0,0,.222-.222V13.838a.221.221,0,0,0-.222-.221H8.694v-.435a5.456,5.456,0,0,1,5.442-5.451Zm-5.442,21.5h10.9v1.7H8.694Z",
    transform: "translate(-2.274 -2.311)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.544,31.256h.023a.222.222,0,0,0,.222-.2A4.1,4.1,0,0,1,27.6,29a.224.224,0,1,0-.356-.273,4.53,4.53,0,0,0-.9,2.282.22.22,0,0,0,.2.25Z",
    transform: "translate(-19.006 -20.611)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.942,25.545a.227.227,0,0,0,.138-.046,4.017,4.017,0,0,1,.6-.393.225.225,0,0,0-.212-.4,4.839,4.839,0,0,0-.669.435.222.222,0,0,0-.037.314.231.231,0,0,0,.175.088Z",
    transform: "translate(-22.742 -17.861)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.064,57.085a3.732,3.732,0,1,0-3.732-3.732A3.736,3.736,0,0,0,63.064,57.085Zm0-7.012a3.284,3.284,0,1,1-3.284,3.284A3.288,3.288,0,0,1,63.064,50.073Z",
    transform: "translate(-41.937 -35.198)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.922,44.738a5.2,5.2,0,0,1,2.887,2.5.234.234,0,0,0,.2.12.2.2,0,0,0,.1-.027.219.219,0,0,0,.093-.3,5.669,5.669,0,0,0-3.137-2.716.223.223,0,0,0-.286.138.226.226,0,0,0,.143.282Z",
    transform: "translate(-54.058 -31.503)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.076,43.726a5.429,5.429,0,0,1,.72.051h.032a.225.225,0,0,0,.032-.448,5.5,5.5,0,0,0-.781-.056.221.221,0,0,0-.221.222.216.216,0,0,0,.218.231Z",
    transform: "translate(-49.949 -30.786)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.784,58.228h1v1a.221.221,0,0,0,.222.222h1.381a.221.221,0,0,0,.221-.222v-1h1a.221.221,0,0,0,.221-.222V56.625A.221.221,0,0,0,68.6,56.4h-1v-1a.221.221,0,0,0-.221-.221H66a.221.221,0,0,0-.222.221v1h-1a.221.221,0,0,0-.222.221v1.381A.225.225,0,0,0,64.784,58.228Zm.226-1.381h1a.221.221,0,0,0,.221-.222v-1h.937v1a.221.221,0,0,0,.221.222h1v.934h-1a.221.221,0,0,0-.221.221v1H66.23V58a.221.221,0,0,0-.221-.221h-1Z",
    transform: "translate(-45.573 -39.065)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.132,35.448a.227.227,0,0,0,.157-.064l1.141-1.141a.226.226,0,0,0-.319-.319L87.97,35.064a.226.226,0,0,0,0,.319.218.218,0,0,0,.162.064Z",
    transform: "translate(-61.799 -24.24)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.969,40.9a.221.221,0,0,0,.222.222H92.8a.222.222,0,1,0,0-.443H91.191A.219.219,0,0,0,90.969,40.9Z",
    transform: "translate(-63.929 -28.985)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.085,31.344a.221.221,0,0,0,.221-.221V29.51a.222.222,0,1,0-.443,0v1.612A.22.22,0,0,0,85.085,31.344Z",
    transform: "translate(-59.685 -21.064)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.433,31.148a.227.227,0,0,0,.157-.064l.263-.263a.226.226,0,0,0-.319-.319l-.263.263a.226.226,0,0,0,0,.319A.256.256,0,0,0,94.433,31.148Z",
    transform: "translate(-66.179 -21.861)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsIcon);
export default __webpack_public_path__ + "static/media/assets-icon.14ce4f6fc3e4d9c522d62c647ad3f9cc.svg";
export { ForwardRef as ReactComponent };